"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.events = exports.Events = void 0;
var Events = /** @class */ (function () {
    function Events() {
        this.observers = [];
    }
    Events.prototype.on = function (event, fn) {
        this.observers.push([event, fn]);
    };
    Events.prototype.off = function (event, fn) {
        this.observers = this.observers.filter(function (subscriber) {
            return subscriber[0] !== event || subscriber[1] !== fn;
        });
    };
    Events.prototype.emit = function (event, data) {
        this.observers.forEach(function (subscriber) {
            try {
                if (subscriber[0] === event)
                    subscriber[1](data);
            }
            catch (e) {
                return;
            }
        });
    };
    return Events;
}());
exports.Events = Events;
exports.events = new Events();
